import React, { useEffect } from 'react';
import { ConfigProvider as AntdConfigProvider } from 'antd';
import { ConfigProvider as AntdMobileConfigProvider, setDefaultConfig as setAntdMobileDefaultConfig } from 'antd-mobile';
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';
import hiIN from 'antd/locale/hi_IN';
import enUSMobile from 'antd-mobile/es/locales/en-US';
import arSAMobile from 'antd-mobile/es/locales/ar-SA';
import { useLanguage } from '../../contexts/LanguageContext';

const localeMap = {
  en: enUS,
  ar: arEG,
  hi: hiIN,
};

// antd-mobile ships its own separate locale system (defaults to zh-CN —
// Chinese — when never configured, which is why an unconfigured app sees
// Chinese button text on its Picker/DatePicker/etc., e.g. TasksPage's
// reassign-assignee Picker). It only has en-US/ar-SA locales of its own (no
// Hindi), so 'hi' falls back to English here rather than leaving antd-mobile
// on its own zh-CN default.
const mobileLocaleMap = {
  en: enUSMobile,
  ar: arSAMobile,
};

const AntdLocaleWrapper = ({ children }) => {
  const { language, isRTL } = useLanguage();

  // <AntdMobileConfigProvider> only reaches components that render inside
  // this tree and call antd-mobile's useConfig() internally. Imperative APIs
  // like Dialog.confirm/Dialog.alert/Modal.confirm don't render inside the
  // tree at call time — they read a separate module-level default (also
  // zh-CN out of the box) via antd-mobile's own setDefaultConfig/
  // getDefaultConfig escape hatch, which the ConfigProvider never touches.
  // Without this, every Dialog.confirm/alert call that doesn't pass its own
  // confirmText/cancelText falls back to Chinese button text regardless of
  // the app's selected language.
  useEffect(() => {
    setAntdMobileDefaultConfig({ locale: mobileLocaleMap[language] || enUSMobile });
  }, [language]);

  return (
    <AntdConfigProvider
      locale={localeMap[language] || enUS}
      direction={isRTL ? 'rtl' : 'ltr'}
      theme={{ token: { zIndexPopupBase: 10000 } }}
    >
      <AntdMobileConfigProvider locale={mobileLocaleMap[language] || enUSMobile}>
        {children}
      </AntdMobileConfigProvider>
    </AntdConfigProvider>
  );
};

export default AntdLocaleWrapper;
